var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorReq(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 84,
    viewBox: "0 0 85 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4742_70864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.7695 38.6504L62.9065 49.7873L51.7695 60.9243",
    stroke: "#08141E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3766 49.6752L61.2016 49.6752",
    stroke: "#08141E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3828 32.1996L12.2459 21.0627L23.3828 9.92578",
    stroke: "#08141E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2439 21.0627L63.0373 21.0627",
    stroke: "#08141E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.6805 60.7766C57.259 62.3415 57.259 64.8931 55.6805 66.458L48.6838 73.394C47.1054 74.9588 47.1054 77.5104 48.6838 79.0752C50.243 80.6209 52.7567 80.6209 54.3159 79.0752L61.4112 72.0412C62.9705 70.4955 65.4842 70.4955 67.0434 72.0412L74.139 79.0753C75.6981 80.621 78.2118 80.621 79.771 79.0753C81.3494 77.5105 81.3494 74.959 79.771 73.3942L72.7742 66.458C71.1957 64.8931 71.1957 62.3415 72.7742 60.7766L79.771 53.8404C81.3494 52.2756 81.3494 49.7241 79.771 48.1593C78.2118 46.6136 75.6981 46.6136 74.139 48.1593L67.0434 55.1934C65.4842 56.7391 62.9705 56.7391 61.4112 55.1934L54.3159 48.1594C52.7567 46.6137 50.243 46.6137 48.6838 48.1594C47.1054 49.7242 47.1054 52.2758 48.6838 53.8406L55.6805 60.7766Z",
    fill: "url(#paint0_radial_4742_70864)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4742_70864",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.9641 47) rotate(41.5724) scale(55.5942 55.5516)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#FF456A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF28A9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4742_70864"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 63,
    fill: "white",
    transform: "translate(4.5 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorReq);
export default __webpack_public_path__ + "static/media/errorReq.b3f778987217ba641bd4bd037b92c5ce.svg";
export { ForwardRef as ReactComponent };